var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup335(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 68,
    viewBox: "0 0 81 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 68,
    fill: "#7399EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9998 47.3334C48.3332 47.3334 54.3332 41.3334 54.3332 34.0001C54.3332 26.6667 48.3332 20.6667 40.9998 20.6667C33.6665 20.6667 27.6665 26.6667 27.6665 34.0001C27.6665 41.3334 33.6665 47.3334 40.9998 47.3334Z",
    stroke: "#002766",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.9998 28.6667C38.9598 28.6667 35.6665 31.9734 35.6665 36.0001C35.6665 37.8267 37.1598 39.3334 38.9998 39.3334C43.0265 39.3334 46.3332 36.0267 46.3332 32.0001C46.3332 30.1734 44.8265 28.6667 42.9998 28.6667Z",
    stroke: "#002766",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup335);
export default __webpack_public_path__ + "static/media/Group 335.8958d95061e9496afa91a24aa1dcc844.svg";
export { ForwardRef as ReactComponent };